import * as React from 'react';

/**
 * @return {React.ReactElement}
 * @constructor
 */
export default function WebinarCount(): React.ReactElement {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.6211 3.625H1.25C0.559896 3.62581 0.0008138 4.1849 0 4.875V13.1009C0.0008138 13.791 0.559896 14.3501 1.25 14.3509H11.6211C12.311 14.3501 12.8703 13.791 12.8711 13.1009V4.875C12.8703 4.1849 12.311 3.62581 11.6211 3.625Z" />
      <path d="M13.7031 10.6995L17.9987 13.0448V4.95703L13.7031 7.30225V10.6995Z" />
    </svg>
  );
}
